import axios from "axios";
import { history } from "../utils";

export const DEFAULT_API_OPTIONS = {
  baseUrl: "/api/",
  timeout: 15000
};

export class ApiServiceBase {
  constructor({ baseUrl, timeout } = DEFAULT_API_OPTIONS) {
    this._axios = axios.create({
      baseURL: baseUrl,
      timeout: timeout,
      headers: {
        // Authorization: `Bearer ${token}`
      }
    });

    this._axios.interceptors.request.use(async (config) => {
      // Do something before request is sent
      // const token = await authService.getAccessToken();
      // config.headers.Authorization = `Bearer ${token}`;
      return config;
    }, (error) => {
      // Do something with request error
      return Promise.reject(error);
    });

    this._axios.interceptors.response.use((response) => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    }, (error) => {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error

      if (error.response) {
        console.log("response data:", error.response.data);
        console.log("response status:", error.response.status);
        console.log("response headers:", error.response.headers);

        // TODO: 401 时自动跳转至登陆界面
        if (error.response.status === 401) {
          const loc = window.location;
          if (!loc.pathname.startsWith("/login")) {
            history.replace("/login", {
              from: {
                pathname: loc.pathname,
                search: loc.search,
                hash: loc.hash
              }
            });
          }
        }
      } else if (error.request) {
        console.log("request:", error.request);
      } else {
        console.log("Axios Error", error.message);
      }
      console.log("config:", error.config);

      return Promise.reject(error);
    });
  }
}

